<template>
    <div>        
        <v-flex>     
            <v-layout row align-center>
                <v-text-field                 
                    :append-icon="selectedColor"
                    @click:clear="selectCleared"
                    @click="showModal"   
                    @focus="onFocus($event)"            
                    v-model="colorText"          
                    :value="value"
                    label="Kleur"       
                    clearable                
                ></v-text-field>        
                <div @click="showPicker=true" class="color-picker-preview"  :style="`background-color:${colorText} `"></div> 
            </v-layout>   
        </v-flex>
        <v-layout row justify-center>
            <v-dialog v-model="showPicker" scrollable max-width="360px">
                <v-card>
                    <v-card-title>
                        Selecteer een kleur                 
                    </v-card-title>
                    <v-card-text style="height: 300px;">
                        <v-layout row wrap>                        
                            <swatches v-model="colors" @input="updateColor"></swatches>                                  
                        </v-layout>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn color="blue darken-1" flat @click="showPicker= false">Sluiten</v-btn>
                    </v-card-actions>  
                </v-card>          
            </v-dialog>   
        </v-layout>
    </div>
</template>

<script>
    import { Swatches } from 'vue-color'
    export default {
        components:{
            Swatches
        },        
        data() {
            return {
                colors:{ h: 150, s: 0.66, v: 0.30 },                
                showPicker:false,
                colorText:"",
            }
        },        
        computed: {
            selectedColor() {
                if(this.colorText){
                    //return this.iconText+" fa-1x primary--text text--lighten-2";
                }
                return "";
            }
        },
        methods: {
            updateColor(item) {
                this.colorText = item.hex
                this.showPicker=false
                this.$emit('input',  this.colorText)
            },
            showModal(){
                this.showPicker=!this.showPicker                
                this.filterText=""

            },
            onFocus($event){
                console.log("komt hier")
                this.showModal()
            },
            selectCleared(){
                this.$emit('input', "")
            }
        },
        
        props:['value'],
        watch: {
            'value': {
                handler:function(newValue){                    
                    this.colorText = newValue;                    
                },
                deep:true
            }
        },
        created(){            
            this.colorText = this.value
        }

    }
</script>

<style scoped>
    .color-picker-preview{
        margin-left:4px; 
        width:26px; 
        height:26px; 
        border:1px 
        solid black;    
        cursor:pointer;    
    }
    .icon-tray{
        width: 50px;
        height: 50px;
        border: 1px solid lightgray;
    }
    .icon-tray:hover{
        background-color:lightgray;
        cursor:pointer;
    }
</style>